import { Avatar } from '@app/components/Avatar';
import type {
  LeadCardUserProfileData,
  LeadCardUserStatsData,
} from '@app/components/LeadCard/data';
import { UserActionsMenu } from '@app/components/LeadCard/ui/UserActionsMenu';
import { UserStatsPopover } from '@app/components/LeadCard/ui/UserStatsPopover';
import { TruncatedHeaderText } from '@app/shared/components';

import type { FC } from 'react';

import './UserProfileHeader.scss';

interface UserProfileHeaderProps {
  profile: LeadCardUserProfileData;
  stats: LeadCardUserStatsData;
}

export const UserProfileHeader: FC<UserProfileHeaderProps> = ({
  profile: { avatarBase64, name },
  stats,
}) => (
  <div className="UserProfileHeader">
    <Avatar
      className="UserProfileHeader__avatar"
      src={avatarBase64}
      nameFirst={name}
      size={36}
      round
    />

    <TruncatedHeaderText
      className="UserProfileHeader__name"
      lineCount={2}
      text={name}
    />

    <div className="UserProfileHeader__actions">
      <UserStatsPopover stats={stats} />
      <UserActionsMenu />
    </div>
  </div>
);
